import { render, staticRenderFns } from "./YKFPYQHMLQPSQ.vue?vue&type=template&id=163ee67b&scoped=true"
import script from "./YKFPYQHMLQPSQ.vue?vue&type=script&lang=js"
export * from "./YKFPYQHMLQPSQ.vue?vue&type=script&lang=js"
import style0 from "./YKFPYQHMLQPSQ.vue?vue&type=style&index=0&id=163ee67b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163ee67b",
  null
  
)

export default component.exports